import React, { useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './occupationalHealth.scss';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import heroImage from './occupational-health-banner.png';
import { Button } from '@sirkka-health/booking-system-ui';
import Image from '@/components/Image';

// Assuming this is your apiData with sample product data
const apiData = [
	{
		title: 'GP Appointments',
		paragraph: 'These health checks are required by law...',
		tags: ['gp', 'doctor'],
		image: heroImage, // Using imported heroImage for demonstration
		bookingUrl: 'https://www.salus-wellness.com/bookings',
	},
	{
		title: 'Health Surveillance',
		paragraph: 'These health checks are required by law...',
		tags: ['health', 'surveillance', 'legal'],
		image: heroImage,
		bookingUrl: 'https://www.salus-wellness.com/bookings',
	},
	{
		title: 'Drug Testing',
		paragraph: 'These health checks are required by law...',
		tags: ['drug', 'hair', 'urine', 'blood', 'alcohol', 'saliva'],
		image: heroImage,
		bookingUrl: 'https://www.salus-wellness.com/bookings',
	},
	// Add more products here
];

const CardContent = ({ title, paragraph, tags, image, bookingUrl }) => (
	<div className="col-12 col-md-6 col-lg-4 mb-4">
		<div
			style={{
				backgroundColor: 'rgb(255, 255, 255)',
				padding: '20px',
				borderRadius: '8px',
				border: '1px solid rgba(203, 205, 215, 0.231372549)',
			}}
		>
			{image && (
				<div
					style={{
						height: '200px',
						overflow: 'hidden',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						marginBottom: '20px',
					}}
				>
					<Image src={image} alt={title} style={{ width: '100%', height: 'auto' }} />
				</div>
			)}
			<h4>{title}</h4>
			<p>{paragraph}</p>
			{tags && (
				<div className="tags">
					{tags.map((tag) => (
						<span key={tag} className="tag">
							{tag}
						</span>
					))}
				</div>
			)}
			{bookingUrl && (
				<a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="d-block mt-3">
					<Button variant="primary" type="button" label="Book now" fullWidth />
				</a>
			)}
		</div>
	</div>
);

const OccupationalHealth = () => {
	const [selectedOption, setSelectedOption] = useState(null);

	const customFilterOption = (candidate, input) => {
		const labelMatch = candidate.label.toLowerCase().includes(input.toLowerCase());
		const tagMatch = candidate.data.tags.some((tag) =>
			tag.toLowerCase().includes(input.toLowerCase())
		);
		return labelMatch || tagMatch;
	};

	const options = apiData.map((data) => ({
		value: data.title,
		label: data.title,
		tags: data.tags,
	}));

	const animatedComponents = makeAnimated();

	// Filter products based on selection or show all products
	const filteredProducts = selectedOption
		? apiData.filter((product) => product.title === selectedOption.label)
		: apiData; // If no option is selected, show all products

	return (
		<>
			<Header title="Occupational Health" />
			<div className="container">
				<div className="row">
					<div className="col-lg-8 mx-auto">
						<div className="px-5 pos-rel mb-70 mt-70">
							<div className="section-text pos-rel">
								<h5>
									We offer bespoke Occupational Health Services to suit each organisation's needs
								</h5>
							</div>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-xl-4 col-lg-4 col-md-12">
						<div
							className="mb-4 ms-2 me-4 mb-lg-0 me-lg-0"
							style={{
								backgroundColor: 'rgb(255, 255, 255)',
								padding: 0,
								paddingBottom: '18px',
								borderRadius: '8px',
								border: '1px solid rgba(203, 205, 215, 0.231372549)',
							}}
						>
							<div className="px-5 pb-4 pt-5">
								<h4 className="mb-15">Search</h4>
								<Select
									components={animatedComponents}
									options={options}
									onChange={setSelectedOption}
									isSearchable={true}
									isClearable={true}
									placeholder="Search Products..."
									filterOption={customFilterOption}
								/>
							</div>
						</div>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-12">
						<section className="team-area pb-90">
							<div className="container">
								<div className="row">
									{filteredProducts.map(
										(
											product,
											index // Use filteredProducts here
										) => (
											<CardContent
												key={index}
												title={product.title}
												paragraph={product.paragraph}
												tags={product.tags}
												image={product.image}
												bookingUrl={product.bookingUrl}
											/>
										)
									)}
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default OccupationalHealth;
